
import Phaser from 'phaser';
import BootScene from './scenes/boot';

function launch() {
  return new Phaser.Game({
    type: Phaser.WEBGL,
    scale: {
      mode: Phaser.Scale.RESIZE,
      width: '100%',
      height: '100%',
    },
    parent: 'welcome-back-page',
    scene: [BootScene],
  });
}

export { launch };
